<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG lead-card">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-brand center>Lead List</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>

        <div>
          <b-card-text>
            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row class="lead_nav align-items-end">
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="Filter.common"
                        placeholder="Type to Search Lead Master and Code" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col md="6" class="col-md-2">
                  <label>Assigned To</label>
                  <model-list-select class="ml-1" :list="$store.getters['common/getAllUserList']" id="assignedTo"
                    @input="debounceSearch" v-model="Filter.assignedTo" option-value="userId" option-text="employeeName"
                    placeholder="Select Assigned User"></model-list-select>
                </b-col>
              </b-row>
              <b-row class="lead_nav align-items-end">
                <b-col md="6" class="col-md-2">
                  <label>Branch</label>

                  <model-list-select class="ml-1" :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                    v-model="Filter.branchfilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="debounceSearch" :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "></model-list-select>
                </b-col>
                <b-col md="3"><label for="clientId">Status Type</label>
                  <model-list-select :list="StatusTypeList" id="StatusType" v-model="Filter.StatusType"
                    option-value="val" option-text="type" placeholder="Status Type"
                    @input="debounceSearch"></model-list-select></b-col>
                <b-col md="3" class="mt-3">
                  <!-- <b-button
                    v-if="
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                    "
                    size="sm"
                    class="ml-1"
                    @click="getReports('Lead_Master_List')"
                    variant="outline-info"
                    >Export</b-button
                  > -->
                  <!-- v-if="
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                    " -->
                  <b-button :disabled="ExcelBtnName != 'Export' ? true : false" class="ml-3"
                    @click="getReports('Lead_Master_List', 'Export')" size="sm" variant="outline-info">{{ ExcelBtnName
                    }}
                    <b-spinner v-if="ExcelBtnName != 'Export'" small label="Small Spinner"></b-spinner></b-button>
                  <b-button size="sm" class="pull-left" @click="AddLead()" variant="primary">Add</b-button>
                  <!-- <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button> -->
                </b-col>
              </b-row>

              <!-- Search Form Input End-->
              <!-- Main table element -->
              <h5 class="text-muted pull-right mt-2 ml-3">
                <small v-if="isLoading == false">{{ totalRows }} Entries</small>
              </h5>
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="LeadList" :fields="fields" :current-page="currentPage"
                  :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection" @filtered="onFiltered" responsive primary-key="lead_id"
                  class="position-relative">
                  <template slot="lead_id" slot-scope="row0">
                    <span>
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="lead_comp_name" slot-scope="row1">
                    <span v-if="row1.item.lead_comp_name">{{
                      row1.item.lead_comp_name
                      }}</span><br />
                    <div :id="'row' + row1.item.lead_id">
                      <md-switch :id="'approval' + row1.item.lead_id" name="approval" class="md-primary"
                        :value="row1.item.is_converted == 1 ? true : false" @change="isConvertLead(row1.item)"
                        :disabled="
                          (($sessionsStorage.get('designation') != 'Admin' &&
                          $sessionsStorage.get('nameUser') != 'Bhavneesh') || (row1.item.is_converted == 1))
                            ? true
                            : false
                        ">
                        <h6>
                          <br />
                          <b-badge :variant="row1.item.is_converted == 1 ? 'success' : 'danger'">{{
                            row1.item.is_converted == 1 ? "Converted" : "Pending"
                            }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <br />
                    <!-- <h6>
                      <b-badge
                        :variant="row1.item.is_converted == 1 ? 'success' : 'danger'"
                        >{{
                          row1.item.is_converted == 1 ? "Converted" : "Pending"
                        }}</b-badge
                      >
                    </h6> -->
                    <span v-if="row1.item.RaisedFrom">Raised From : {{ row1.item.RaisedFrom }}</span><br />
                    <b-button class="mt-2" style="font-size: 0.675rem" size="sm"
                      @click="View_MinutesOfMeeting(row1.item.lead_id)" variant="outline-info">View MM</b-button>
                  </template>
                  <template slot="lead_address" slot-scope="row1">
                    <span v-if="row1.item.lead_address">
                      Address : {{ row1.item.lead_address }}
                      <br />
                    </span>
                    <span v-if="row1.item.branch_address">
                      Branch Address{{ row1.item.branch_address }}
                      <br />
                    </span>
                    <span v-if="row1.item.office_address">
                      Office Address{{ row1.item.office_address }}
                      <br />
                    </span>
                  </template>
                  <template slot="lead_shipmentType" slot-scope="row2">
                    <span v-if="row2.item.lead_shipmentType">
                      Shipment Type : {{ row2.item.lead_shipmentType }}
                      <br />
                    </span>
                    <span v-if="row2.item.lead_moduelType">
                      Module Type : {{ row2.item.lead_moduelType }}
                      <br />
                    </span>
                    <span v-if="row2.item.lead_jobType">
                      Job Type : {{ row2.item.lead_jobType }}
                      <br />
                    </span>
                    <span v-if="row2.item.lead_container_type">
                      Container Type : {{ row2.item.lead_container_type }}
                      <br />
                    </span>
                    <span v-if="row2.item.lead_por_exp">
                      Exp/Imp POR : {{ row2.item.lead_por_exp }}
                      <br />
                    </span>
                    <span v-if="row2.item.lead_pol_exp">
                      Exp/Imp POL : {{ row2.item.lead_pol_exp }}
                      <br />
                    </span>
                    <span v-if="row2.item.lead_pod_exp">
                      Exp/Imp POD : {{ row2.item.lead_pod_exp }}
                      <br />
                    </span>
                  </template>
                  <template slot="is_active" slot-scope="row3">
                    <div :id="'row' + row3.item.lead_id">
                      <md-switch :id="'approval' + row3.item.lead_id" name="approval" class="md-primary"
                        :value="row3.item.is_active == 1 ? true : false" @change="activateUser(row3.item)">
                        <h6>
                          <br />
                          <b-badge :variant="row3.item.is_active == 1 ? 'success' : 'danger'">{{
                            row3.item.is_active == 1 ? "Active" : "In-Active"
                            }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <br />
                    <!-- <h6>
                      <b-badge
                        :variant="row3.item.is_active == 1 ? 'success' : 'danger'"
                        >{{ row3.item.is_active == 1 ? "Active" : "In-Active" }}</b-badge
                      >
                    </h6> -->
                  </template>
                  <template slot="created_at" slot-scope="row3">
                    <span v-if="row3.item.created_at">
                      Created : {{ row3.item.created_at }}
                      <br />
                    </span>
                    <span v-if="row3.item.createdBy">
                      Created By : {{ row3.item.createdBy }}
                      <br />
                    </span>
                    <span v-if="row3.item.updated_at">
                      Updated : {{ row3.item.updated_at }}
                      <br />
                    </span>
                    <span v-if="row3.item.updatedBy">
                      Updated By : {{ row3.item.updatedBy }}
                      <br />
                    </span>
                  </template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" style="font-size: 0.675rem" @click="editLeadLocation(row2.item)"
                      id="addButtonLoader" size="sm">Update</b-button>
                    <b-button variant="outline-primary" style="font-size: 0.675rem" @click="SendLead(row2.item)"
                      id="addButtonLoader" size="sm">Send Email</b-button>

                    <b-button variant="outline-primary" style="font-size: 0.675rem" @click="AddLeadTrack(row2.item)"
                      id="addButtonLoader" size="sm">Add MoM</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
              <b-modal class="modal-dialog-doc" size="xl" no-close-on-esc no-close-on-backdrop
                ref="ViewMinutesOfMeeting-modal" hide-footer title="View Minutes Of Meeting">
                <div class="accordion" role="tablist" v-for="(item, index) in View_MinutesOfMeetingList" :key="index">
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab"
                      @click="ActiveAccordion(item.activeStatus, index)">
                      <b-row>
                        <b-col cols="4">
                          <b-button style="font-size: 0.675rem" size="sm" class="text-left"
                            :variant="item.is_followup_done == 0 ? 'warning' : 'info'">{{ item.meeting_code
                            }}</b-button>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <b-button style="font-size: 0.675rem" size="sm" class="text-left"
                            :variant="item.is_followup_done == 0 ? 'warning' : 'info'"><b>Lead User : </b>{{
                            item.lead_user }}</b-button>
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <b-button style="font-size: 0.675rem" size="sm" class="text-right"
                            :variant="item.is_followup_done == 0 ? 'warning' : 'info'">{{ item.lead_DateTime
                            }}</b-button>
                        </b-col>
                      </b-row>
                    </b-card-header>
                    <!-- {{ item.activeStatus }} -->
                    <b-card-body v-if="item.activeStatus">
                      <b-card-text><b>Lead Date : </b>{{
                        item.lead_DateTime
                        }}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="text-right"><b-button style="font-size: 0.675rem" size="sm" class="text-left"
                            :variant="item.is_followup_done == 0 ? 'danger' : 'success'" @click="
                              item.is_followup_done == 0
                                ? FollowupDone(
                                    item.fk_lead_id,
                                    item.track_id,
                                    item.is_followup_done == 0 ? 1 : 0
                                  )
                                : ''
                            ">{{
                            item.is_followup_done == 0
                            ? "Followup Pending"
                            : "Followup Done"
                            }}</b-button></span>
                      </b-card-text>
                      <b-card-text><b>Pridel User : </b>{{ item.lead_pridel_user }}</b-card-text>
                      <b-card-text><b>Lead User : </b>{{ item.lead_user }}</b-card-text>
                      <b-card-text><b>Other User : </b>{{ item.other_lead_user_name }}</b-card-text>
                      <b-card-text><b>Lead Venue : </b>{{ item.lead_venue }}</b-card-text>
                      <b-card-text><b>Minutes Of Meeting : </b><span
                          v-for="(line, lineNumber) of item.lead_minutes_of_meeting.split('\n')"
                          v-bind:key="lineNumber">
                          {{ line }}<br /> </span></b-card-text>
                      <b-card-text><b>Further Action : </b>{{ item.lead_further_action }}</b-card-text>
                      <b-card-text><b>Followup Date : </b>{{ item.lead_followupdate }}</b-card-text>
                      <b-card-text><b>Followup Time : </b>{{ item.lead_followupTime }}</b-card-text>
                      <b-card-text><b>Assign To : </b>{{ item.assigned_user_txt }}</b-card-text>
                      <b-card-text><b>Remark : </b><span v-for="(lRemark, rindex) of item.lead_remark.split('\n')"
                          v-bind:key="rindex">
                          {{ lRemark }}<br /> </span></b-card-text>
                    </b-card-body>
                  </b-card>
                </div>
                <b-button class="mt-3" variant="outline-danger" block @click="hideViewMinutesOfMeetingModal">Close
                </b-button>
              </b-modal>
            </div>
          </b-card-text>
        </div>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import LeadService from "../../services/LeadService.js";
import ClientUserService from "../../services/ClientUserService.js";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      );
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      );
      // alert(globalPermissionStatus("Lead"))
      if (globalPermissionStatus("Lead")) {
        this.$store.dispatch("setCurrentRoute", "/lead/leadlist");
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.getData("Normal");
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export",
      isLoading: false,
      fields: [
        {
          key: "lead_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "lead_comp_name",
          label: "Lead Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "lead_address",
          label: "Address",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "lead_shipmentType",
          label: "Shipment Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "is_active",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "created_at",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      Filter: {
        common: "",
        branchfilter: "",
        assignedTo: "",
        StatusType: "",
        dateRange: { startDate: "", endDate: "" },
      },
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      validate: true,
      shipmentTypeList: [
        {
          shipmentTypeVal: "Sea",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "Air",
          shipmentTypeText: "Air",
        },
      ],
      moduelTypeList: [
        {
          text: "Export",
          value: "Export",
        },
        {
          text: "Import",
          value: "Import",
        },
      ],
      jobTypeList: [
        {
          text: "FF",
          value: "FF",
        },
        {
          text: "CC",
          value: "CC",
        },
        {
          text: "TPT",
          value: "TPT",
        },
      ],
      View_MinutesOfMeetingList: [],
      LeadList: [],
      StatusTypeList: [
        {
          type: "Pending",
          val: "2",
        },
        {
          type: "Converted",
          val: "1",
        },
      ],
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    
     isConvertLead(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.is_converted = this.itemObj.is_converted == 1 ? 0 : 1;
      let paylod = {
        tableName: "lead_master",
        tableId: "lead_id",
        tableIsActive: "is_converted",
        value1: this.itemObj.is_converted,
        tableVal: item.lead_id,
        manual:'Yes',
        isMailSend:'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    activateUser(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.is_active = this.itemObj.is_active == 1 ? 0 : 1;
      let paylod = {
        tableName: "lead_master",
        tableId: "lead_id",
        tableIsActive: "is_active",
        value1: this.itemObj.is_active,
        tableVal: item.lead_id,
        isMailSend:'No',
        manual:'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    goBack() {
      window.history.go(-1);
    },
    FollowupDone(fk_lead_id, track_id, is_followup_done) {
      if (fk_lead_id && track_id) {
        this.isLoading = true;
        let payload = {
          itemCode: "UpdateFollowup",
          is_followup_done: is_followup_done,
          track_id: track_id,
          lead_id: fk_lead_id,
        };
        payload = JSON.stringify(payload);
        if (this.validate != false) {
          LeadService.getAllLeadList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              this.View_MinutesOfMeetingList = data.View_MinutesOfMeetingList;
              this.isLoading = false;
              // this.View_MinutesOfMeeting(fk_lead_id);
              this.$sessionsStorage.set("edit_lead_id", fk_lead_id);
              this.$router.push({
                path: "/lead/leadTrack",
              });
            })
            .catch((error) => {
              console.log("Catch on View_MinutesOfMeetingList Error: ", error);
            });
        }
      }
    },
    ActiveAccordion(activeStatus, index) {
      let flag = false;
      if (activeStatus == true) {
        flag = false;
      } else {
        flag = true;
      }
      // alert(flag);
      this.View_MinutesOfMeetingList[index]["activeStatus"] = flag;
      this.View_MinutesOfMeetingList.forEach((element, index2) => {
        if (index2 != index) {
          element.activeStatus = false;
        }
      });
    },
    View_MinutesOfMeeting(lead_id) {
      if (lead_id) {
        this.isLoading = true;
        let payload = {
          itemCode: "View_MinutesOfMeeting",
          lead_id: lead_id,
        };
        payload = JSON.stringify(payload);
        if (this.validate != false) {
          LeadService.getAllLeadList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              this.View_MinutesOfMeetingList = data.View_MinutesOfMeetingList;
              this.isLoading = false;
              this.$refs["ViewMinutesOfMeeting-modal"].show();
              console.log(
                "Catch on View_MinutesOfMeetingList: ",
                this.View_MinutesOfMeetingList
              );
            })
            .catch((error) => {
              console.log("Catch on View_MinutesOfMeetingList Error: ", error);
            });
        }
      }
    },
    hideViewMinutesOfMeetingModal() {
      this.$refs["ViewMinutesOfMeeting-modal"].hide();
    },
    AddLeadTrack(item) {
      this.$sessionsStorage.set("edit_lead_id", item.lead_id);
      this.$router.push({
        path: "/lead/leadTrack",
      });
    },
    editLeadLocation(item) {
      console.log("Item=>", item);
      this.$sessionsStorage.set("edit_lead_id", item.lead_id);
      this.$router.push({
        path: "/lead/upsertLead",
      });
    },
    SendLead(item) {
      if (item.lead_id) {
        this.isLoading = true;
        let payload = {
          itemCode: "Send_Lead_Mail",
          leadForm: item,
        };
        payload = JSON.stringify(payload);
        if (this.validate != false) {
          LeadService.getAllLeadList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (data.lead_id != "" && data.lead_id != undefined) {
                if (data.find == 1 || data.find == 2) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                }
                if (data.flag == true) {
                  this.$router.push({
                    path: "/lead/leadlist",
                  });
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
            })
            .catch((error) => {
              console.log("Catch on Proforma Error: ", error);
            });
        }
      }
    },
    AddLead() {
      this.$sessionsStorage.set("edit_lead_id", "");
      this.$router.push({
        path: "/lead/upsertLead",
      });
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getData("Excell");
    },
    getReports_bak(id, btnName) {
      let payload = {
        excelId: id,
        searchVal: this.filter,
        Filter: this.Filter,
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      this.ExcelBtnName = btnName;
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
        // alert(ExcelName)
        // if (ExcelName) {
        //   window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + ExcelName;
        // }
      }
    },
    activateLeadMaster() {
      if (this.LeadMaster.is_active == 1 || this.LeadMaster.is_active == true) {
        this.LeadMaster.is_active = false;
      } else if (this.LeadMaster.is_active == 0 || this.LeadMaster.is_active == false) {
        this.LeadMaster.is_active = true;
      }
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getData("Normal");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.Filter = { common: "", branchfilter: "", assignedTo: "", StatusType: "" };
      this.getData("Normal");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {},

    getData(type) {
      this.LeadList = [];
      this.isLoading = true;
      let payload = {
        itemCode: "ALL_Leads",
        searchVal: this.filter,
        Filter: this.Filter,
        type: type,
      };
      LeadService.getAllLeadList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excell") {
              this.ExcelBtnName = "Export As Excel";
              if (data.LeadList.length > 0) {
                this.LeadList = data.LeadList;
                this.totalRows = data.LeadList.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.LeadList.length > 0) {
                this.LeadList = data.LeadList;
                this.totalRows = data.LeadList.length;
                console.log(" getAllExpenseList response=>", data);
              }
            }

            console.log(" Lead List response=>", data);
          } else {
            this.LeadList = [];
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Lead List Error: ", error);
        });
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.lead_nav .form-group {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// leadList.vue?5c174fdb